import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'


//Langues
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import global_es from "./languages/es/global.json"
import global_en from "./languages/en/global.json"
import global_jp from "./languages/jp/global.json"


//STYLE
import "./assets/scss/main.scss"
import { SUPPORTED_LANGUAGES } from './configuration/globalConstants';

const queryClient = new QueryClient()

const storedLang = localStorage.getItem('lang')
const initialLang = SUPPORTED_LANGUAGES.includes(storedLang) ? storedLang : 'en'

i18next.init({
  interpolation: { escapeValue: false },
  fallbackLng: 'en',
  lng: initialLang,
  resources: {
    es: {
      global: global_es
    },
    en: {
      global: global_en
    },
    jp: {
      global: global_jp
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18next}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
